/**
 * Spaces membership-list lifecycle: initial load and refetch on membership
 * change events. Mirrors {@link useConversationsAuthLifecycleEffects}.
 */

import { useEffect } from 'react';
import { onSpacesChanged } from '../../services/spacesMembershipEvents';

export interface SpacesLifecycleEffectsParams {
  fetchSpaces: () => Promise<void>;
  fetchLurkedSpaces: () => Promise<void>;
}

export function useSpacesLifecycleEffects(params: SpacesLifecycleEffectsParams): void {
  const { fetchSpaces, fetchLurkedSpaces } = params;

  useEffect(() => {
    void fetchSpaces();
    void fetchLurkedSpaces();
  }, [fetchSpaces, fetchLurkedSpaces]);

  useEffect(
    () =>
      onSpacesChanged(() => {
        void fetchSpaces();
        void fetchLurkedSpaces();
      }),
    [fetchSpaces, fetchLurkedSpaces],
  );
}
